import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsRefundPage.less';
export default class GoodsRefundPage extends OfficialPage {
  state = {
    orderInfoStatus: '',
    is_vip_goods: '',
    goodsList: [],
    refundTypeData: [
      { title: '未收到货物/拒收货物（申请全额退款）' },
      { title: '已收到货物，不退货，仅退款（申请部分退款）' },
      { title: '已收到货物，退货退款（申请全额退款）' }
    ],
    refundReasonData: [
      { title: '多拍/拍错/不想要' },
      { title: '快递延期' },
      { title: '未按约定时间发货' },
      { title: '快递记录出错' },
      { title: '内容与描述不符' },
      { title: '其它' }
    ],
    refundWayData: [{ title: '原付款方式退回' }, { title: '退还为储值金' }],
    refundJourneyReasonData: [
      { title: '未保持餐品完整' },
      { title: '骑手服务态度恶劣' },
      { title: '骑手额外索取费用' },
      { title: '骑手诱导退单' },
      { title: '骑手提前点击送达' },
      { title: '骑手虚假标记异常' },
      { title: '少餐错餐' }
    ],
    showRefundType: true,
    showRefundReason: true,
    showRefundWay: true,
    typeIndex: '',
    reasonIndex: '',
    wayIndex: '',
    imagesArr: [],
    express: '',
    maxRefundPrice: '',
    refundPrice: '',
    refundDes: '',
    isShowPayInstruct: true,
    is_group_buy_order: 0,
    sameCity: 0,
    storeStyle: {}
  }
  orderId = ''
  franchiseeId = ''
  origin = ''
  applyRefundId = ''
  refundGoods = []

  constructor(props) {
    super(props);
    document.title = '申请退款';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
    this.franchiseeId = options.franchisee || ''
    this.origin = options.type
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getAppECStoreConfig()
    if (this.origin == 'apply') {
      let data = app.getCurrentPages()[app.getCurrentPages().length - 2].data.goodsList;
      let goodsList = []
      let refundGoods = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].selected) {
          goodsList.push(data[i])
          refundGoods.push({
            goods_id: data[i].goods_id,
            model_id: data[i].model_id,
            num: data[i].preview_refund_num
          })
        }
      }
      this.setData({
        goodsList: goodsList
      })
      this.refundGoods = refundGoods
      this.calculateRefundPrice()
    }
    this.getOrderDetail()
  }
  getOrderDetail = () => {
    var _this = this
    app.getOrderDetail({
      data: {
        order_id: _this.orderId,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let formData = res.data[0].form_data
        let is_vip_goods = res.data[0].vip_cut_price == 0 ? 0 : 1
        let deliverType =
          (formData.ecommerce_info.intra_city_data &&
            formData.ecommerce_info.intra_city_data.deliver_type) ||
          0
        let pickUpType = formData.pick_up_type
        let sameCity = 0
        if (formData.wx_local_express_order) {
          sameCity = 1
        }
        if (_this.origin == 'editor') {
          let refundGoods = formData.refund_apply.refund_goods
          for (let j = 0; j < refundGoods.length; j++) {
            refundGoods[j].goods_name = refundGoods[j].title
            refundGoods[j].preview_refund_num = refundGoods[j].num
            refundGoods[j].model_value = refundGoods[j].model_name
          }
          _this.setData({
            goodsList: refundGoods,
            typeIndex: formData.refund_apply.refund_type,
            reasonIndex: formData.refund_apply.refund_reason,
            wayIndex: formData.refund_apply.refund_mode,
            imagesArr: formData.refund_apply.img_url || [],
            refundDes: formData.refund_apply.description,
            refundPrice: formData.refund_apply.refund_price
          })
          _this.applyRefundId = formData.refund_apply.id
          _this.refundGoods = refundGoods
          _this.calculateRefundPrice()
        }
        _this.setData({
          orignalStatus:
            (formData.refund_info && formData.refund_info.orignal_status) || '',
          orderInfoStatus: formData.status,
          is_group_buy_order: formData.is_group_buy_order || 0,
          is_vip_goods: is_vip_goods,
          pickUpType: pickUpType,
          deliveryStatus:
            (formData.ecommerce_info.ecommerce_transport_order &&
              formData.ecommerce_info.ecommerce_transport_order.status) ||
            '',
          sameCity: sameCity
        })
        _this.getRefundConfigByPickUpType(formData.pick_up_type)
        if (pickUpType == 2) {
          _this.getBuyerCancelReason(deliverType)
        }
      }
    })
  }
  calculateRefundPrice = type => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/calculateRefundPrice',
      method: 'post',
      data: {
        order_id: _this.orderId,
        refund_goods: _this.refundGoods,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let newData = {
          express: res.data.has_express,
          maxRefundPrice: res.data.refund_goods_price
        }
        _this.origin == 'editor'
          ? ''
          : (newData['refundPrice'] = res.data.refund_goods_price)
        _this.setData(newData)
      }
    })
  }
  closeRefundBox = () => {
    this.setData({
      showRefundType: true,
      showRefundReason: true,
      showRefundWay: true
    })
  }
  showRefundBox = event => {
    let _this = this
    let type = event.currentTarget.dataset.type
    let newData = {}
    switch (type) {
      case 'type':
        newData.showRefundType = false
        break
      case 'reason':
        if (_this.data.typeIndex !== '') {
          newData.showRefundReason = false
        }
        break
      case 'way':
        if (_this.data.typeIndex !== '' && _this.data.reasonIndex !== '') {
          newData.showRefundWay = false
        }
        break
    }
    this.setData(newData)
  }
  selectReason = event => {
    let type = event.currentTarget.dataset.type
    let index = event.currentTarget.dataset.index
    let newData = {}
    let _this = this
    switch (type) {
      case 'type':
        newData.typeIndex = index
        if (index == 0) {
          newData.refundPrice = _this.data.maxRefundPrice
        }
        newData.showRefundType = true
        newData.showRefundReason = false
        break
      case 'reason':
        newData.reasonIndex = index
        newData.showRefundReason = true
        newData.showRefundWay = false
        break
      case 'way':
        newData.wayIndex = index
        newData.showRefundWay = true
        break
    }
    this.setData(newData)
  }
  chooseImage = () => {
    let _this = this
    let img_arr = _this.data.imagesArr || []
    app.chooseImage(function (images) {
      let data = {}
      data.imagesArr = img_arr.concat(images)
      _this.setData(data)
    }, 8 - img_arr.length)
  }
  deleteImage = event => {
    let picIndex = event.currentTarget.dataset.index
    let img_arr = this.data.imagesArr
    let data = {}
    img_arr.splice(picIndex, 1)
    data.imagesArr = img_arr
    this.setData(data)
  }
  previewImage = event => {
    let _this = this
    let index = event.currentTarget.dataset.index
    app.previewImage({
      current: _this.data.imagesArr[index],
      urls: _this.data.imagesArr
    })
  }
  prevRefundBox = event => {
    let type = event.currentTarget.dataset.type
    let newData = {}
    switch (type) {
      case 'reason':
        newData.showRefundType = false
        newData.showRefundReason = true
        break
      case 'way':
        newData.showRefundReason = false
        newData.showRefundWay = true
        break
    }
    this.setData(newData)
  }
  cancelRefund = () => {
    app.turnBack()
  }
  stopPropagation = event => { }
  changeRefundPrice = event => {
    this.setData({
      refundPrice: event.target.value
    })
  }
  inputRefundDes = event => {
    this.setData({
      refundDes: event.target.value
    })
  }
  sureRefund = () => {
    let _this = this
    if (_this.data.typeIndex === '') {
      app.showModal({
        content: '请填写退款类型'
      })
      return
    }
    if (_this.data.reasonIndex === '') {
      app.showModal({
        content: '请填写退款原因'
      })
      return
    }
    if (_this.data.wayIndex === '') {
      app.showModal({
        content: '请填写退款方式'
      })
      return
    }
    if (_this.data.refund_price <= 0) {
      app.showModal({
        content: '退款金额有误'
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=appShop/applyRefund',
      method: 'post',
      data: {
        sub_shop_app_id: _this.franchiseeId,
        apply_id: _this.applyRefundId,
        order_id: _this.orderId,
        refund_price: _this.data.refundPrice,
        refund_goods: _this.refundGoods,
        refund_type: _this.data.typeIndex,
        refund_reason: _this.data.reasonIndex,
        refund_mode: _this.data.wayIndex,
        description: _this.data.refundDes.replace(/\n|\r\n/g, '<br />'),
        img_url: _this.data.imagesArr
      },
      success: function (res) {
        if (_this.origin == 'apply') {
          app.turnBack({
            delta: 2
          })
        } else {
          app.turnBack()
        }
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }
  closeMask = () => {
    this.setData({
      isShowInstructionMask: false
    })
  }
  checkInstruction = () => {
    this.setData({
      isShowInstructionMask: true
    })
  }
  hidePaymentInstruct = () => {
    this.setData({
      isShowPayInstruct: false
    })
  }
  getRefundConfigByPickUpType = type => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
      data: {
        sub_shop_app_id: _this.franchiseeId,
        pick_up_type: type
      },
      success: function (res) {
        let data = res.data.config_data
        _this.setData({
          refundWithGoods: data.refund_with_goods,
          isFullRefund: data.is_full_refund,
          refundTobalance: data.refund_to_balance,
          contactPhone: data.address ? data.address.phone : ''
        })
      }
    })
  }
  getBuyerCancelReason = type => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getBuyerCancelReason',
      data: {
        deliver_type: type
      },
      success: function (res) {
        let data = res.data
        let refundJourneyReasonData = []
        for (let i in data) {
          refundJourneyReasonData.push({
            title: data[i]
          })
        }
        _this.setData({
          refundJourneyReasonData: refundJourneyReasonData
        })
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      storeStyle,
      pickUpType,
      isShowPayInstruct,
      goodsList,
      is_group_buy_order,
      typeIndex,
      refundTypeData,
      reasonIndex,
      refundJourneyReasonData,
      refundReasonData,
      wayIndex,
      refundWayData,
      refundPrice,
      showRefundType,
      showRefundReason,
      showRefundWay,
      maxRefundPrice,
      express,
      refundDes,
      isShowInstructionMask,
      imagesArr,
      refundWithGoods,
      orderInfoStatus,
      orignalStatus,
      deliveryStatus,
      sameCity,
      refundTobalance,
      contactPhone
    } = this.state

    return (
      <div className="official-page goods-refund-page">
        <TopNav title="申请退款" />
        {pickUpType == 2 && isShowPayInstruct && (
          <div
            className="payment-instructions"
            style={convertLineStyleData(
              'background:' +
              storeStyle.theme +
              '1A;' +
              'color:' +
              storeStyle.theme
            )}
          >
            <span
              onClick={this.hidePaymentInstruct}
              className="ico-moon icon-closes"
            ></span>
            <span>赔付说明</span>
            <span
              className="pull-right check-instructions"
              style={convertLineStyleData('border-color:' + storeStyle.theme)}
              onClick={this.checkInstruction}
            >
              立即查看
            </span>
          </div>
        )}
        <div className="refund-box">
          {goodsList.map((goods, index) => {
            return (
              <div className="goods-detail-box" key={goods.goods_id}>
                <img src={goods.cover} />
                <div>
                  <div className="goods-name">
                    {is_group_buy_order != 0 && (
                      <span className="is-seckill">拼团</span>
                    )}
                    {goods.is_seckill == 1 && (
                      <span className="is-seckill">秒杀</span>
                    )}
                    {goods.is_vip_goods == 1 && (
                      <span className="is-seckill">会员价</span>
                    )}
                    {goods.goods_name}
                  </div>
                  {goods.model_value && (
                    <div className="goods-rules">{goods.model_value}</div>
                  )}
                  <div className="goods-price">
                    {goods.use_integral == 0 ? (
                      <React.Fragment>
                        <span
                          className="colorff7"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {'¥' + goods.price}
                        </span>
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          {(goods.price != '0.00' ||
                            !goods.use_integral ||
                            goods.use_integral == 0) && (
                              <span
                                className="colorff7"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                              >
                                {'¥' + goods.price}
                              </span>
                            )}
                          {goods.use_integral &&
                            goods.use_integral != 0 &&
                            goods.price != '0.00' && (
                              <span
                                className="colorff7"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                              >
                                +
                            </span>
                            )}
                          {goods.use_integral && (
                            <span
                              className="colorff7"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                            >
                              {goods.use_integral + '积分'}
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    <span className="pull-right">
                      {'x ' + goods.preview_refund_num}
                    </span>
                  </div>
                </div>
              </div>
            )
          })}
          <div className="type-reason-way">
            <div onClick={this.showRefundBox} data-type="type">
              <span className="type-reason-way-title">退款类型</span>
              <span className="pull-right ico-moon icon-rightarrow"></span>
              <span
                className={
                  'pull-right select-reason ' +
                  (typeIndex !== '' ? 'select' : '')
                }
              >
                {refundTypeData[typeIndex] && refundTypeData[typeIndex].title || '请选择'}
              </span>
            </div>
            <div onClick={this.showRefundBox} data-type="reason">
              <span className="type-reason-way-title">退款原因</span>
              <span className="pull-right ico-moon icon-rightarrow"></span>
              <span
                className={
                  'pull-right select-reason ' +
                  (reasonIndex !== '' ? 'select' : '')
                }
              >
                {(pickUpType == 2
                  ? refundJourneyReasonData[reasonIndex] && refundJourneyReasonData[reasonIndex].title
                  : (refundReasonData[reasonIndex] && refundReasonData[reasonIndex].title)) || '请选择退款原因'}
              </span>
            </div>
            <div onClick={this.showRefundBox} data-type="way">
              <span className="type-reason-way-title">退款方式</span>
              <span className="pull-right ico-moon icon-rightarrow"></span>
              <span
                className={
                  'pull-right select-reason ' +
                  (wayIndex !== '' ? 'select' : '')
                }
              >
                {(refundWayData[wayIndex] && refundWayData[wayIndex].title) || '请选择退款方式'}
              </span>
              {wayIndex == 1 && (
                <div className="storage-tip">
                  注：储值金不会跟着退款一起退回，在商家同意退款后，还需用户点击“确认退款”，才会退回。
                </div>
              )}
            </div>
          </div>
          <div className="refund-price-box">
            <div>
              <span className="refund-price-title">退款金额</span>
              {typeIndex != 1 && (
                <span
                  className="pull-right refund-price"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                >
                  {'¥' + refundPrice}
                </span>
              )}
              {typeIndex == 1 &&
                showRefundType &&
                showRefundReason &&
                showRefundWay && (
                  <input
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="pull-right refund-price-input"
                    type="digit"
                    value={refundPrice}
                    onChange={this.changeRefundPrice}
                  />
                )}
            </div>
            <div className="refund-price-detail">
              {'最多退¥' + maxRefundPrice + '，含配送费¥' + express + '元'}
            </div>
            {wayIndex == 1 && (
              <div className="refund-price-detail">
                {'最终退款储值金额 ¥' + refundPrice + '元'}
              </div>
            )}
          </div>
          <div className="refund-instruct">
            {!isShowInstructionMask && (
              <div className="refund-instruct-title">
                <span className="refund-instruct-label">退款说明</span>
                {showRefundType && showRefundReason && showRefundWay && (
                  <input
                    className="refund-instruct-input"
                    type="text"
                    value={refundDes}
                    onChange={this.inputRefundDes}
                    placeholder="选填"
                  />
                )}
              </div>
            )}
            <div className="images-box">
              {imagesArr.map((item, index) => {
                return (
                  <div key={index}>
                    <span
                      className="delete-image ico-moon icon-closes"
                      onClick={this.deleteImage}
                      data-index={index}
                    ></span>
                    <img
                      src={item}
                      data-index={index}
                      onClick={this.previewImage}
                    />
                  </div>
                )
              })}
              {imagesArr.length < 8 && (
                <div className="add-images" onClick={this.chooseImage}>
                  <span className="ico-moon icon-goods-add-image"></span>
                  <div>添加图片</div>
                </div>
              )}
            </div>
            <div className="images-length">{imagesArr.length + '/8'}</div>
          </div>
          <div className="refund-bottom">
            <div className="refund-cancel" onClick={this.cancelRefund}>
              取消
            </div>
            <div
              className="refund-submit"
              onClick={this.sureRefund}
              style={convertLineStyleData('background:' + storeStyle.theme)}
            >
              提交
            </div>
          </div>
        </div>
        {/*  退款类型  */}
        <div
          className="refund-type-mask"
          onClick={this.closeRefundBox}
          hidden={showRefundType}
        >
          <div className="refund-type-box" onClick={this.stopPropagation}>
            <div className="refund-type-title">退款类型</div>
            <div className="refund-type-menu">
              {refundTypeData.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      hidden={
                        (refundWithGoods == 0 ||
                          orderInfoStatus == 1 ||
                          orignalStatus == 1 ||
                          deliveryStatus == 3 ||
                          pickUpType == 3) &&
                        index == 2 &&
                        !sameCity
                      }
                      className="refund-type-list"
                      onClick={this.selectReason}
                      data-index={index}
                      data-type="type"
                    >
                      <span
                        style={convertLineStyleData(
                          typeIndex === index ? 'color:' + storeStyle.theme : ''
                        )}
                        className={typeIndex === index ? 'select' : ''}
                      >
                        {item.title}
                      </span>
                      <span className="pull-right ico-moon icon-rightarrow"></span>
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
            <div
              className="refund-type-close"
              onClick={this.closeRefundBox}
              style={convertLineStyleData('background:' + storeStyle.theme)}
            >
              关闭
            </div>
          </div>
        </div>
        {/*  退款原因  */}
        <div
          className="refund-type-mask"
          onClick={this.closeRefundBox}
          hidden={showRefundReason}
        >
          <div className="refund-type-box" onClick={this.stopPropagation}>
            <div className="refund-type-title">退款原因</div>
            <div className="refund-type-menu">
              {(pickUpType == 2
                ? refundJourneyReasonData
                : refundReasonData
              ).map((item, index) => {
                return (
                  <div
                    key={index}
                    className="refund-type-list"
                    onClick={this.selectReason}
                    data-index={index}
                    data-type="reason"
                  >
                    <span
                      style={convertLineStyleData(
                        reasonIndex === index ? 'color:' + storeStyle.theme : ''
                      )}
                      className={reasonIndex === index ? 'select' : ''}
                    >
                      {item.title}
                    </span>
                    <span className="pull-right ico-moon icon-rightarrow"></span>
                  </div>
                )
              })}
            </div>
            <div className="refund-reason-close">
              <span
                className="pre-btn"
                onClick={this.prevRefundBox}
                data-type="reason"
              >
                上一步
              </span>
              <span
                className="close-btn"
                onClick={this.closeRefundBox}
                style={convertLineStyleData('background:' + storeStyle.theme)}
              >
                关闭
              </span>
            </div>
          </div>
        </div>
        {/*  退款方式  */}
        <div
          className="refund-type-mask"
          onClick={this.closeRefundBox}
          hidden={showRefundWay}
        >
          <div className="refund-type-box" onClick={this.stopPropagation}>
            <div className="refund-type-title">退款方式</div>
            <div className="refund-type-menu">
              {refundWayData.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      hidden={refundTobalance == 0 && index == 1}
                      className="refund-type-list"
                      onClick={this.selectReason}
                      data-index={index}
                      data-type="way"
                    >
                      <span
                        style={convertLineStyleData(
                          wayIndex === index ? 'color:' + storeStyle.theme : ''
                        )}
                        className={wayIndex === index ? 'select' : ''}
                      >
                        {item.title}
                      </span>
                      <span className="pull-right ico-moon icon-rightarrow"></span>
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
            <div className="refund-reason-close">
              <span
                className="pre-btn"
                onClick={this.prevRefundBox}
                data-type="way"
              >
                上一步
              </span>
              <span
                className="close-btn"
                onClick={this.closeRefundBox}
                style={convertLineStyleData('background:' + storeStyle.theme)}
              >
                关闭
              </span>
            </div>
          </div>
        </div>
        {isShowInstructionMask && (
          <div className="payment-instructions-mask">
            <div className="payment-instructions-box">
              <div className="title">赔付说明</div>
              <div>
                1.根据实际情况定位骑手还是商家问题，必要时上传产品详情照片1-3张
              </div>
              <div>
                2.流程：投诉后商家将会收到您的反馈，并在
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>1-3</span>
                个工作日内对提交的内容进行审核，审核无误将会赔付金额到您的储值账户中
              </div>
              <div>
                3.最高赔付
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {maxRefundPrice}
                </span>
                元
              </div>
              {contactPhone && refundWithGoods == 1 && (
                <div>
                  4.若长时间未处理，可拨打热线电话
                  <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                    {contactPhone}
                  </span>
                </div>
              )}
              <div
                className="known-btn"
                style={convertLineStyleData('color:' + storeStyle.theme)}
                onClick={this.closeMask}
              >
                知道了
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-refund-page/GoodsRefundPage.jsx